export default "__VITE_PUBLIC_ASSET__c0f6be22__"